import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  FlatList,
} from "react-native";
import React, { useEffect, useState } from "react";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppScreens } from "../../Utility/AppScreens";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppImages } from "../../../utility/AppImages";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { enumAddEditPublicPrivateScreen } from "../Event/CreatePrivateEventScreen";
import { toast } from "react-toastify";
import PaginationComponent from "../../../utility/pagination/Pagination";
import SupportChatSkeleton from "../../../Components/skeleton-components/SupportChatSkeleton";
import Header from "./Common/Header";
import CommonTextInputWeb from "../../../common/CommonTextInputWeb";
import { Keyboard } from "react-native";
import FilterDropdown from "../../../Components/super-admin/dispute-management-components/FilterDropdow";
import { adminDisputesGetAll } from "../../../services/disputesAPI";
import { getLoginData } from "../../../utility/AppStoreData";
import { ScreenBGGradientView } from "../../../common/CommonView";

export default function DisputeManagementScreen() {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [pageLastEvaluatedKey, setPageLastEvaluatedKey] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [arrOnGoingDispute, setArrOnGoingDispute] = useState([]);
  const [filteredDisputes, setFilteredDisputes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalPagesCount, setTotalPagesCount] = useState(1);
  const [searchEvent, setSearchEvent] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [accessToken, setAccessToken] = React.useState("");
  const sellRates = {
    bronze: 0.89,
    silver: 8.99,
    gold: 89.9,
    platinum: 899,
  };
  useEffect(() => {
    const fetchDisputes = async () => {
      const data = await getLoginData();

      if (data != null) {
        setAccessToken(data.AccessToken);
      }
      setShowLoader(true);
      try {
        const token = data.AccessToken;
        const { disputes, lastEvaluatedKey, count } = await adminDisputesGetAll(
          token,
          currentPage === 1 ? null : pageLastEvaluatedKey,
          Number(pageLimit)
        );
        const totalPages = Math.ceil(count / pageLimit);
        setTotalPagesCount(totalPages);
        setPageLastEvaluatedKey(lastEvaluatedKey);
        setArrOnGoingDispute(disputes);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setShowLoader(false);
      }
    };

    fetchDisputes();
  }, [currentPage, pageLimit]);

  useEffect(() => {
    let filtered = arrOnGoingDispute;

    if (searchEvent) {
      filtered = filtered.filter(
        (item) =>
          item.DisputeID.toLowerCase().includes(searchEvent.toLowerCase()) ||
          item.eventDetails.eventTitle
            .toLowerCase()
            .includes(searchEvent.toLowerCase()) ||
          item.eventDetails.gameTitle
            .toLowerCase()
            .includes(searchEvent.toLowerCase())
      );
    }

    if (selectedFilter) {
      filtered = filtered.filter((item) => {
        const disputeDate = new Date(item.Timestamp);
        const currentDate = new Date();
        const todayStart = new Date(currentDate.setHours(0, 0, 0, 0));
        const todayEnd = new Date(currentDate.setHours(23, 59, 59, 999));
        const weekStart = new Date(todayStart);
        weekStart.setDate(todayStart.getDate() - todayStart.getDay());
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);
        weekEnd.setHours(23, 59, 59, 999);

        if (selectedFilter === "today") {
          return disputeDate >= todayStart && disputeDate <= todayEnd;
        } else if (selectedFilter === "this_week") {
          return disputeDate >= weekStart && disputeDate <= weekEnd;
        } else if (selectedFilter === "resolved") {
          return item.UserRewarded.toLowerCase() === "resolved";
        } else if (selectedFilter === "pending") {
          return item.UserRewarded.toLowerCase() === "pending verification";
        }
        return true;
      });
    }

    setFilteredDisputes(filtered);
  }, [arrOnGoingDispute, searchEvent, selectedFilter]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleLimitChange = (limit) => {
    setPageLimit(limit);
    setCurrentPage(1);
  };

  const navigateToDetail = (ticketData) => {
    navigateToScreen(navigation, AppScreens.CreateTicketEventScreen, {
        checkScreen: enumAddEditPublicPrivateScreen.Edit,
        ticketData: ticketData,
      });
  };
  const renderDisputeCenterItem = ({ item, index }) => {
    const totalStakePrice = item.eventDetails?.stakes
      ? item.eventDetails.stakes
          .reduce((acc, stake) => {
            const sellRate = sellRates[stake.type.toLowerCase()] || 0;
            return acc + stake.quantity * sellRate;
          }, 0)
          .toFixed(2)
      : "0.00";
    return (
      <View
        key={index}
        style={{
          flexDirection: "row",
          flex: 1,
          padding: 6,
          borderRadius: 6,
          gap: 10,
          backgroundColor: AppColors.purple_6D08C333,
          marginBottom: 12,
        }}
      >
        <View
          // style={styles.itemWidth}
          style={{
            width: "7%",
            backgroundColor: AppColors.appViolentColor_6D08C3,
            padding: 12,
            borderRadius: 10,
          }}
        >
          <Text
            numberOfLines={1}
            style={[AppFontStyle.REGULAR_ANYBODY_14, { textAlign: "center" }]}
          >
            {item.DisputeID}
          </Text>
        </View>
        <View style={[styles.itemWidth, { justifyContent: "center" }]}>
          <Text numberOfLines={1} style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
            {item.eventDetails.eventTitle}
          </Text>
        </View>
        <View style={[styles.itemWidth, { justifyContent: "center" }]}>
          <Text numberOfLines={1} style={[AppFontStyle.REGULAR_ANYBODY_12, {}]}>
            {item.eventDetails.gameTitle}
          </Text>
        </View>
        <View style={[styles.itemWidth, { justifyContent: "center" }]}>
          <Text numberOfLines={1} style={[AppFontStyle.REGULAR_ANYBODY_12, {}]}>
            {`1v1 Challenge - $${totalStakePrice} Wagers`}
          </Text>
        </View>
        <View style={[styles.itemWidth, { justifyContent: "center" }]}>
          <Text
            numberOfLines={1}
            style={[
              AppFontStyle.REGULAR_ANYBODY_12,
              {
                color:
                  item.UserRewarded.toLowerCase() === "resolved"
                    ? AppColors.green_0DFF00
                    : AppColors.yellow_FF0,
              },
            ]}
          >
            {item.UserRewarded.toLowerCase() === "resolved"
              ? "Resolved"
              : item.UserRewarded}
          </Text>
        </View>
        <View style={[styles.itemWidth, { justifyContent: "center" }]}>
          <TouchableOpacity
            // onPress={() => navigateToDetail(item)}
            onPress={() => {
              navigateToScreen(navigation, AppScreens.DisputeDetailScreen, {
                  eventId: item.eventDetails.eventID,
                });
            }}
            style={{
              flexDirection: "row",
              columnGap: 8,
              justifyContent: "center",
              backgroundColor: AppColors.gray_4A4A4A,
              borderRadius: 12,
              padding: 10,
              width: 144,
            }}
          >
            <Text
              numberOfLines={1}
              style={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
            >
              View details
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  const renderEmptyState = () => (
    <View style={styles.emptyStateContainer}>
      <Text style={styles.emptyStateText}>No tickets available</Text>
    </View>
  );

  const renderHeader = () => (
    <View
      style={{
        flexDirection: "row",
        marginVertical: 24,
        borderRadius: 12,
        gap: 10,
        backgroundColor: AppColors.grayColor_565656,
      }}
    >
      {[
        "ID",
        "Event Name",
        "Game Title",
        "Match Type",
        "Status",
        "Actions",
      ].map((item, index) => (
        <View
          key={index}
          style={[
            {
              padding: 4,
              justifyContent: "flex-start",
              flexDirection: "row",
              gap: 8,
              paddingVertical: 10,
              width: item === "ID" ? "7%" : "18%",
            },
            // styles.itemWidth,
          ]}
        >
          <Text style={[AppFontStyle.BOLD_ANYBODY_16, {}]}>{item}</Text>
        </View>
      ))}
    </View>
  );

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />

      <View style={styles.container}>
        <View style={[{ columnGap: 10 }]}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_32, { color: AppColors.white }]}
            >
              Dispute Management
            </Text>
            <View style={{ flexDirection: "row", gap: 50 }}>
              <View style={{ width: 314 }}>
                <CommonTextInputWeb
                  placeholder="Search here"
                  mainStyle={{
                    backgroundColor: AppColors.purple_453B50,
                    borderWidth: 0,
                    borderColor: "transparent",
                    paddingHorizontal: 12,
                    paddingVertical: 10,
                    flex: 1,
                    borderRadius: 8,
                  }}
                  inputStyle={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { paddingVertical: 0, paddingHorizontal: 0 },
                  ]}
                  keyboardType="default"
                  value={searchEvent}
                  onChangeText={setSearchEvent}
                  prefixIconVisibility={true}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  isPassword={false}
                  prefixIcon={AppImages.icSearchWhite}
                  iconStyle={{ width: 24, height: 24 }}
                />
              </View>
              <FilterDropdown onFilterChange={setSelectedFilter} />
            </View>
          </View>
          <View
            style={{
              height: 2,
              backgroundColor: AppColors.grayColor_505050,
              marginTop: 10,
            }}
          />
        </View>

        {showLoader ? (
          <SupportChatSkeleton />
        ) : (
          <>
            <FlatList
              showsHorizontalScrollIndicator={false}
              data={filteredDisputes}
              ListHeaderComponent={renderHeader}
              renderItem={renderDisputeCenterItem}
              keyExtractor={(item, index) => `${item.DisputeID}-${index}`}
              ListEmptyComponent={renderEmptyState}
              style={{ flex: 1 }}
              contentContainerStyle={{ paddingBottom: 20 }}
            />
            <View style={[{ columnGap: 10, margin: 20 }]}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                <PaginationComponent
                  currentPage={currentPage}
                  totalPagesCount={totalPagesCount}
                  onPageChange={handlePageChange}
                  pageLimit={pageLimit}
                  onLimitChange={handleLimitChange}
                />
              </View>
            </View>
          </>
        )}
      </View>
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    emptyStateContainer: {
      flex: 1,
      justifyContent: "center",
      marginTop: 100,
      alignItems: "center",
    },
    emptyStateDescription: {
      color: "white",
      fontSize: 14,
      marginVertical: 10,
    },
    emptyStateText: {
      color: "white",
      fontSize: 16,
      fontWeight: "bold",
    },
    itemWidth: {
      width: "18%",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      itemWidth: {
        width: 250,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      itemWidth: {
        width: 220,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      itemWidth: {
        width: 250,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      itemWidth: {
        width: 250,
      },
    },
  }
);
